import Vue from 'vue'
import store from "@/store"
import classicParams from "./classic-params"
import * as models from '../store/models/*.js'

const Store = {

  required: true,

  onReady: null,

  install(Vue, options) {
    Vue.prototype.$store = store

    this.onReady = new Promise((resolve, reject) => {

      classicParams.onReady.then((params) => {
        // Determine API Host URL
        let apiHost = (() => {
          switch(params.env) {
            case "dev":
              return "http://localhost:9999"
            case "test":
              return "https://test-api.studysync.com"
            case "staging":
              return "https://staging-api.studysync.com"
            case "production":
              return "https://api.studysync.com"
            default:
              return process.env.API_HOST
            }
        })()
        // Tell our DS adapter to use api host as basePath
        _.set(store.adapters.http.defaults, "basePath", `${apiHost}/v2`)
        _.set(store.adapters.http.defaults, "httpConfig.headers.common.token", sessionStorage.token)
        // Expose the store to window if we're in dev
        if(params.env == 'dev') {
          window.$store = store
        }
        // Ready
        resolve()
      })

    })
  }

}

Vue.use(Store)

export default Store



// WEBPACK FOOTER //
// ./src/initializers/store.js